<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [frameworkComponents]="frameworkComponents"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    enableColResize
    enableSorting
    rowHeight="22"
    multiSortKey="ctrl"
    (mouseup)="onMouseUp($event)"
    (contextmenu)="handleClick($event)"
    [ngClass]="{'fullTempStyled': isFullTempStyle === true}"
    [class._bfx_flash]="flashRow"
  >
  </ag-grid-angular>
</div>
<bmark-hedge-orders-context-menu [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bmark-hedge-orders-context-menu>
<bfx-blotter-column-selector [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bfx-blotter-column-selector>
